import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import TaskList from './Task/List';
import TaskCreate from './Task/Create';
import TaskDetail from './Task/Detail';
import { paymentPeriods } from '../../../shared/lookup';
import { injectIntl } from "react-intl";


const defaultFields = {
    Subject : { visible: false, label: '', required: false },
    RfqRelation: { visible: false, label: '', required: false },
    Description: { visible: false, label: '', required: false },
    Comments: { visible: false, label: '', required: false },
    ItemsList: { visible: false, label: '', required: false },
    TotalListPrice: { visible: false, label: '', required: false },
    CompensationDescription: { visible: false, label: '', required: false },
    TotalAssessed: { visible: false, label: '', required: false },
    TotalPrice: { visible: false, label: '', required: false },
    StartDate: { visible: false, label: '', required: false },
    CompletionDate: { visible: false, label: '', required: false },
    DelayAmount: { visible: false, label: '', required: false },
    DelayPaymentPeriod: { visible: false, label: '', required: false },
    CENTaskOrderOption: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };
    fields.Subject =  { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    if (resources.DescriptionLabel) {
        fields.Description = { visible: true, label: resources.DescriptionLabel, required: true };
    }
    if (resources.ItemsListLabel) {
        fields.ItemsList = { visible: true, label: resources.ItemsListLabel, required: true };
    }
    if (resources.TotalListPriceLabel) {
        fields.TotalListPrice = { visible: true, label: resources.TotalListPriceLabel, required: true };
    }
    if (resources.CompensationDescriptionLabel) {
        fields.CompensationDescription = { visible: true, label: resources.CompensationDescriptionLabel, required: true };
    }
    if (resources.TotalAssessedLabel) {
        fields.TotalAssessed = { visible: true, label: resources.TotalAssessedLabel, required: true };
    }
    if (resources.TotalPriceLabel) {
        fields.TotalPrice = { visible: true, label: resources.TotalPriceLabel, required: true };
    }
    if (resources.StartDateLabel) {
        fields.StartDate = { visible: true, label: resources.StartDateLabel, required: true };
    }
    if (resources.CompletionDateLabel) {
        fields.CompletionDate = { visible: true, label: resources.CompletionDateLabel, required: true };
    }
    if (resources.DelayAmountLabel) {
        fields.DelayAmount = { visible: true, label: resources.DelayAmountLabel, required: true };
    }
    if (resources.DelayPaymentPeriodLabel) {
        fields.DelayPaymentPeriod = { visible: true, label: resources.DelayPaymentPeriodLabel, required: true };
    }

    if (placeholdersQA.Fields) {
        placeholdersQA.Fields.values.forEach(fieldItem => {
            const field = fields[fieldItem.field];
            if (field) {
                field.visible = fieldItem.isActive;
                field.label = fieldItem.display;
                field.required = fieldItem.isActive;
            }
        });
    }

    if (placeholdersQA.RFQRelationEnabled) {
        const rfqEnabled = placeholdersQA.RFQRelationEnabled?.values
            .find(phItem => phItem.field === 'RFQRelationEnabled').isActive;
        const rfqRequired = placeholdersQA.RFQRelationRequired?.values
            .find(phItem => phItem.field === 'RFQRelationRequired').isActive;
        fields.RfqRelation = {
            visible: rfqEnabled,
            label: (workflowsQA['62'] || {}).notificationName +' ID',
            required: rfqRequired
        };
    }

    if (workflowsQA['103']) {
        const CENTaskOrderRelationEnabled = !!(workflowsQA['103']?.placeholders.find(ph => ph.replacementKey === 'TaskOrderOptionEnabled')
            .values.find(phItem => phItem.field === 'TaskOrderOptionEnabled').isActive);
        fields.CENTaskOrderOption = {
            visible: CENTaskOrderRelationEnabled,
            label: '',
            required: false
        };
    }

    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;

    fields.Type.clauses = clauses;

    return fields;
}


class TaskPmRouter extends React.Component {
    constructor(props) {
        super(props);
        this.documentType = 'DocumentPmTask';
        this.notifyingParty = props.workflowItem.notifyingParty;

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;


        this.taskOrderCertifiedStartDateFieldName = null;

        if (props.resources.CertifiedStartDateLabel) {
            this.taskOrderCertifiedStartDateFieldName = props.resources.CertifiedStartDateLabel;
        }
        else if (this.props.workflowsQA['117']) {
            try {
                this.taskOrderCertifiedDateField = this.props.workflowsQA['117'].placeholders.find(ph => ph.replacementKey === 'TaskOrderStartFields')
                    .values.find(phItem => phItem.field === 'CertifiedDate');

                if (this.taskOrderCertifiedDateField?.isActive) {
                    this.taskOrderCertifiedStartDateFieldName = this.taskOrderCertifiedDateField.display;
                }
            } catch (error) {
                console.log('TaskOrderStartFields placeholder not available!');
            }
        }

        this.taskOrderCertifiedCompletionDateFieldName = null;

        if (props.resources.CertifiedCompletionDateLabel) {
            this.taskOrderCertifiedCompletionDateFieldName = props.resources.CertifiedCompletionDateLabel;
        }
        else if (this.props.workflowsQA['117']) {
            try {
                this.taskOrderCertifiedDateField = this.props.workflowsQA['117'].placeholders.find(ph => ph.replacementKey === 'TaskOrderCompletionFields')
                    .values.find(phItem => phItem.field === 'CertifiedDate');

                if (this.taskOrderCertifiedDateField?.isActive) {
                    this.taskOrderCertifiedCompletionDateFieldName = this.taskOrderCertifiedDateField.display;
                }
            } catch (error) {
                console.log('TaskOrderCompletionFields placeholder not available!');
            }
        }

        this.paymentPeriods = paymentPeriods.map(p => (this.props.intl.formatMessage({ id: "GENERAL.FORMS." + p })));
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <>
                <Routes caseSensitive>
                    <Route
                        path={workflowItem.config.paths.list}
                        exact
                        element={<TaskList
                            {...this.props}
                            paymentPeriods={this.paymentPeriods}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={this.notificationType}
                            taskOrderCertifiedStartDateFieldName={this.taskOrderCertifiedStartDateFieldName}
                            taskOrderCertifiedCompletionDateFieldName={this.taskOrderCertifiedCompletionDateFieldName}
                        />}
                    />
                    <Route
                        path={workflowItem.config.paths.create}
                        exact
                        element={
                            workflowItem.userFilters.mainNotice.createAllowed ? (
                                <TaskCreate
                                    {...this.props}
                                    paymentPeriods={this.paymentPeriods}
                                    notificationType={this.notificationType}
                                    title={this.notificationName}
                                    rfqRelationRequired={this.rfqRelationRequired}
                                />) : (
                                <Navigate replace to={workflowItem.paths.defaultPath} />
                            )
                        }
                    />
                    <Route
                        path={'/:notificationid/*'}
                        exact
                        element={<TaskDetail
                            {...this.props}
                            paymentPeriods={this.paymentPeriods}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            documentType={this.documentType}
                            notificationType={this.notificationType}
                            rfqRelationRequired={this.rfqRelationRequired}
                            toNotificationName={this.toNotificationName}
                        />}
                    />
                </Routes>
            </>
        );
    }
}



export default injectIntl(TaskPmRouter);